import { Chip, Stack } from '@mui/material';

import type { ConversationalFormOption } from '@karehero/models';

export interface QuickRepliesProps {
  options: ConversationalFormOption[];
  isDisabled?: boolean;
  onChoose: (option: ConversationalFormOption) => void;
}

/**
 * QuickReplies offers a step's options as chips just above the text field, so
 * the likely answers sit where the typing does. They wrap onto more lines
 * rather than run off the side, where a phone gives no sign there are more.
 */
export const QuickReplies = ({
  options,
  isDisabled,
  onChoose,
}: QuickRepliesProps) => (
  <Stack
    direction='row'
    spacing={1}
    role='group'
    aria-label='Suggested answers'
    useFlexGap
    sx={{ flexWrap: 'wrap', pb: 0.25 }}
  >
    {options.map((option) => (
      <Chip
        key={option.id}
        label={option.label}
        disabled={isDisabled}
        onClick={() => onChoose(option)}
        variant={option.isPrimary === false ? 'chatReplyQuiet' : 'chatReply'}
        sx={{ flexShrink: 0 }}
      />
    ))}
  </Stack>
);

QuickReplies.displayName = 'QuickReplies';
export default QuickReplies;
